










import {
    setWindowScrollTop,
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    defineComponent,
    computed,
    onMounted,
    onBeforeUnmount,
    ref,
    watch,
    SetupContext,
    Ref,
} from '@vue/composition-api';

import { appLocale } from '@src/config/locale';
import authenticationStoreIndex from '@store/modules/data/authentication/authenticationIndex';
import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import modalStore from '@store/modules/ui/shared/modal/modalIndex';

import {
    addLanguagePathToURL,
    appendSiteParamsToURL,
    paramsRequiringLogin,
} from './SportCallerBase';

export default defineComponent({
    name: 'SportCallerContainer',
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    setup(props, { emit }) {
        let src = addLanguagePathToURL(props.url, appLocale.locale);

        const { route } = useVueRouter();
        src = appendSiteParamsToURL(src, route.value.query);

        const iFrame = ref<HTMLIFrameElement>();
        const iFrameOrigin = new URL(src).origin;

        const modalModule = useVuexStore<typeof modalStore>('ui/modal');
        const setModal = modalModule.action('setModal');

        function requestLogin() {
            setModal(modalCodes.login);
        }

        const authenticationStore = useVuexStore<typeof authenticationStoreIndex>('data/authentication');
        const user = authenticationStore.getter('user');

        const externalGameId = computed(() => (user.value ? user.value.externalGameId : null));

        onMounted(() => {
            const hasParamsRequireingLogin = [...paramsRequiringLogin.values()].some((param) => !!route.value.query[param]);
            if (hasParamsRequireingLogin && !externalGameId.value) {
                requestLogin();
            }
        });

        addIFrameMessageListener(iFrameOrigin, { emit, requestLogin });
        useSyncUserWithIFrame(iFrame, externalGameId, iFrameOrigin);

        return {
            src: src.toString(),
            iFrame,
        };
    },
});

function useSyncUserWithIFrame(iFrame: Ref<HTMLIFrameElement | undefined>, externalGameId: Ref<string | null>, originalOrigin: string) {
    function sendUserId() {
        if (iFrame.value?.contentWindow) {
            iFrame.value.contentWindow.postMessage(
                JSON.stringify({
                    userId: externalGameId.value,
                }),
                originalOrigin,
            );
        }
    }

    watch(externalGameId, () => {
        sendUserId();
    });
}

function addIFrameMessageListener(iFrameOrigin: string, { emit, requestLogin }: { emit: SetupContext['emit']; requestLogin: () => void }) {
    function onMessageListener(e: MessageEvent) {
        if (e.origin !== iFrameOrigin) {
            return;
        }

        if (e.data === 'notAuthenticated') {
            requestLogin();
        } else if (e.data === 'scrollToTop') {
            setWindowScrollTop(0);
        } else {
            try {
                const data = JSON.parse(e.data);
                if (data.messageType === 'redirect') {
                    emit('redirect', data);
                }
            } catch (e) {}
        }
    }

    window.addEventListener('message', onMessageListener);

    onBeforeUnmount(() => {
        window.removeEventListener('message', onMessageListener);
    });
}
